import{gql as e}from"@apollo/client";import{GELADA_PROJECT_FRAGMENT as t}from"../../graphql/fragments/geladaProject.fragment.js";const o=e`
  query getPaginatedGeladaProjects(
    $shouldIncludeProjectDomain: Boolean = false
    $shouldIncludeProjectLogo: Boolean = false
    $shouldIncludeProjectSettings: Boolean = false
    $shouldIncludeProjectTheme: Boolean = false
    $after: String
    $first: Int
    $filter: String
    $organisationKey: String!
    $isFilteringActive: Boolean = false
  ) {
    project {
      organisationProjects(after: $after, first: $first, filter: $filter, organisationKey: $organisationKey, isFilteringActive: $isFilteringActive) {
        totalCount
        edges {
          cursor
          node {
            ...geladaProjectFragment
          }
        }
      }
    }
  }
  ${t}
`;export{o as GET_PAGINATED_PROJECTS};
//# sourceMappingURL=useGetPaginatedGeladaProjects.graphql.js.map
